import { api } from "../app/api";
import { useAsync } from "../app/useAsync";
import { StatusChip } from "../components/StatusChip";

export function DashboardPage() {
  const health = useAsync(api.health, []);
  const shopify = useAsync(api.shopifyStatus, []);
  const stats = useAsync(api.stats, []);

  return (
    <>
      <h1>Migration Dashboard</h1>
      <p className="page-sub">
        Internal control platform for migrating Sandlot Ruck Club data into
        Shopify customers and metaobjects.
      </p>

      <div className="grid" style={{ marginBottom: "1.2rem" }}>
        <div className="card">
          <h3>Migration Status</h3>
          <table>
            <tbody>
              <tr><td>Source</td><td className="muted">Sandlot Archive</td></tr>
              <tr><td>Destination</td><td className="muted">Shopify</td></tr>
              <tr>
                <td>Mode</td>
                <td><StatusChip tone="warn" label="Preview only" /></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="card">
          <h3>Shopify Writes</h3>
          <div style={{ marginTop: 6 }}>
            <StatusChip tone="warn" label="Disabled" />
          </div>
          <p className="muted" style={{ marginTop: 10 }}>
            Requires approval and the migration flag enabled.
          </p>
        </div>
      </div>

      <div className="grid">
        <div className="card">
          <h3>System</h3>
          <div className="stat">
            {health.loading ? "…" : health.data ? "OK" : "Down"}
          </div>
          <p className="muted">
            {health.data?.environment ?? (health.error ? "unreachable" : "")}
          </p>
        </div>

        <div className="card">
          <h3>Shopify</h3>
          <div style={{ marginTop: 6 }}>
            {shopify.loading ? (
              <span className="muted">checking…</span>
            ) : shopify.data?.configured ? (
              <StatusChip tone="ok" label="Configured" />
            ) : (
              <StatusChip tone="warn" label="Not configured" />
            )}
          </div>
          <p className="muted" style={{ marginTop: 10 }}>
            {shopify.data?.storeDomain ?? "no store domain set"}
          </p>
        </div>

        <div className="card">
          <h3>Customer Matches</h3>
          <div className="stat">
            {stats.loading ? "…" : (stats.data?.totals.matches ?? 0)}
          </div>
          <p className="muted">total recorded</p>
        </div>

        <div className="card">
          <h3>Migration Jobs</h3>
          <div className="stat">
            {stats.loading ? "…" : (stats.data?.totals.jobs ?? 0)}
          </div>
          <p className="muted">total runs</p>
        </div>
      </div>

      {stats.error && (
        <p className="muted">Stats unavailable ({stats.error}).</p>
      )}
    </>
  );
}
